// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".planDialog .el-dialog__body,.planDialog .el-dialog__footer,.planDialog .el-dialog__header{padding-right:0;padding-left:0}", ""]);
// Exports
module.exports = exports;
